import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { fetchData, postData } from "../../services/apiServices";
import debounce from "lodash/debounce";

const MatchData = () => {
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState("");
  const [userType, setUserType] = useState("all");
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [statusTab, setStatusTab] = useState("upcoming");
  const openViewModal = (row) => {
    setSelectedAccount(row);
    setFormData(row);
    setViewModal(true);
  };
  const columns = [
    {
      name: "Match",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <img src={row.home_team_logo} alt="" width="24" height="24" />
          <strong>{row.home_team}</strong>
          <span>vs</span>
          <strong>{row.away_team}</strong>
          <img src={row.away_team_logo} alt="" width="24" height="24" />
        </div>
      ),
    },
    {
      name: "Sport",
      selector: (row) => row.sport_title,
      sortable: true,
    },
    {
      name: "Start Time",
      selector: (row) => new Date(row.commence_time).toLocaleString(),
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`badge ${
            row.status === "live"
              ? "bg-danger"
              : row.status === "finished"
                ? "bg-dark"
                : row.status === "cancelled"
                  ? "bg-secondary"
                  : "bg-success"
          }`}
        >
          {row.status}
        </span>
      ),
    },

    {
      name: "Score",
      cell: (row) =>
        row.scores?.length
          ? row.scores.map((s) => `${s.name}: ${s.score}`).join(" | ")
          : "-",
    },
    {
      name: "winner",
      selector: (row) => row?.winner || "-",
      sortable: true,
    },
  ];
  const getData = async (page) => {
    setPending(true);
    try {
      const params = {
        page,
        limit: perPage,
        status: statusTab,
      };

      const response = await fetchData("api/admin/getMatches", params);

      if (response?.status) {
        setRows(response.data);
        setTotalRows(response.pagination.totalMatches);
      } else {
        setRows([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error(error);
      setRows([]);
    } finally {
      setPending(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      getData(1, searchQuery);
      setCurrentPage(1);
    }, 300),
    [perPage],
  );

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    debouncedSearch(searchValue);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    getData(page);
  };

  useEffect(() => {
    getData(1);
  }, [statusTab]);

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex gap-3 align-items-center">
            {/* <Input
              type="select"
              value={userType}
              onChange={handleUserTypeChange}
              style={{ width: "150px" }}
            >
              <option value="all">All Users</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
            </Input> */}
          </div>
          {/* <Button color="primary" onClick={toggleModal}>
            Create User
          </Button> */}
        </div>
        <div className="mb-3 d-flex gap-2">
          {["upcoming", "live", "finished", "cancelled"].map((status) => (
            <Button
              key={status}
              color={statusTab === status ? "primary" : "secondary"}
              onClick={() => {
                setStatusTab(status);
                setCurrentPage(1);
              }}
            >
              {status.toUpperCase()}
            </Button>
          ))}
        </div>
        <DataTable
          columns={columns}
          data={rows}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressPending={pending}
          responsive
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 30, 50, 100]}
        />
      </CardBody>
    </Card>
  );
};

export { MatchData };
